import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import PricingData from "../../data/pricing/PricingData.json";
import { FaCheck} from "react-icons/fa";


const getPriceingData = PricingData;

const billed = [
    {
        id: 1,
        label: "الدفع السنوي"
    },
    {
        id: 2,
        label: "الدفع الشهري"
    }
]

const PricingOne = () => {
    const [isActive, setActive] = useState("");
    const [selectedLink, setSelectedLink] = useState(""); // حالة جديدة لتتبع الرابط المحدد

    useEffect(() => {
        setActive(billed[1].label.toLowerCase()); // تعيين الدفع الشهري كافتراضي
    }, []);

    const handleChange = (e) => {
        setActive(e.target.textContent.toLowerCase());
        setSelectedLink(""); // إعادة تعيين الرابط المحدد عند تغيير الفترة
    };

    const handleStartNowClick = () => {
        // قم بفحص الرابط المحدد وتحديد السلوك المناسب
        if (selectedLink === "سنوي") {
            window.location.href = getPriceingData[0].yearlyLink; // استخدام window.location.href لفتح رابط خارجي
        } else if (selectedLink === "شهري") {
            window.location.href = getPriceingData[0].monthlyLink; // استخدام window.location.href لفتح رابط خارجي
        } else {
            console.log("الرابط غير محدد");
        }
    };

    return (
        <>
            <div className="pricing-billing-duration">
                <ul>
                    {billed.map((data) => (
                        <li className="nav-item" key={data.id}>
                            <button onClick={handleChange} className={`nav-link ${data.label.toLocaleLowerCase() === isActive ? "active" : ""}`}>
                                {data.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="row">
            {getPriceingData.map((data, index) => (
                <div className="col-lg-4" key={index}>
                    <div className="pricing-table pricing-borderd">
                        <div className="pricing-header">
                            <h3 className="title">{data.title}</h3>
                            <span className="subtitle">{data.subtitle}</span>
                            <div className="price-wrap">
                                <div className="yearly-pricing">
                                    <span className="amount">{billed[0].label.toLowerCase() === isActive ? data.yprice : data.mprice}</span>
                                    <span className="duration">{billed[0].label.toLowerCase() === isActive ? data.yduration : data.mduration}</span>
                                </div>
                            </div>
                            <div className="pricing-btn">
                                <a href={billed[0].label.toLowerCase() === isActive ? data.yearlyLink : data.monthlyLink} className="axil-btn btn-large btn-borderd" onClick={() => setSelectedLink(isActive)}>
                                    ابدأ الآن
                                </a>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-unstyled">
                                {data.facility.map((facility, index) => (
                                    <li key={index}><FaCheck /> {facility}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            ))}
            </div>
        </>
    )
}

export default PricingOne;